// ============================================================================
// JAMB Learn Content — English
// Shared from WAEC learn bank (SS1+SS2+SS3 merged, no SS-level divisions shown)
// ============================================================================

import { WAEC_ENGLISH_LEARN_SS1 } from '../../waec/learn/ss1/english';
import { WAEC_ENGLISH_LEARN_SS2 } from '../../waec/learn/ss2/english';
import { WAEC_ENGLISH_LEARN_SS3 } from '../../waec/learn/ss3/english';

export const JAMB_LEARN_ENGLISH = [
  ...WAEC_ENGLISH_LEARN_SS1,
  ...WAEC_ENGLISH_LEARN_SS2,
  ...WAEC_ENGLISH_LEARN_SS3,
];
